module.exports = __webpack_public_path__ + "img/5002617_orig.560ad0ba.jpg";